module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamonds@2x.d37f644.webp";